import React, { useEffect, useState, memo } from 'react';
import { gql, useQuery } from '@apollo/client';
import { domToReact } from 'html-react-parser';
import parse from 'html-react-parser';
import { Link } from 'react-router-dom';
import readConfig from '../../utils/readClientConfiguration'; // Pełna ścieżka względem src
import productionConfiguration from '../../config/default.json';
import CertifiedShop from './CertifiedShop'
import './Footer.scss';
const phoneSupportNumber = readConfig(productionConfiguration, 'phoneSupportNumber');

const FETCH_FOOTER = gql`
    query getCmsBlocks($identifiers: [String]) {
        cmsHydratedBlocks(identifiers: $identifiers) {
            items {
                title
                identifier
                hydrated_content
            }
        }
    }
`;

const replaceHTMLNodesWithReact = (domNode) => {
    if (!domNode || !domNode.name) return null;

    const { name, attribs, children } = domNode;

    if (name === 'div' && attribs?.class === 'smdWrapperTag') {
        return <CertifiedShop/>;
    }

    if (name === 'a') {
        if (attribs?.href?.startsWith('tel:')) {
            return null;
        }

        try {
            const { pathname } = new URL(attribs.href || '', typeof window !== 'undefined' ? window.location.origin : 'http://localhost');
            const processedLink = pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
            return <Link to={processedLink}>{domToReact(children)}</Link>;
        } catch (e) {
            console.error('Error processing link:', e);
            return null;
        }
    }

    return null;
};

const Footer = () => {
    const [isOnTop, setIsOnTop] = useState(true);

    const { data, loading, error } = useQuery(FETCH_FOOTER, {
        variables: { identifiers: ['footer_block'] },
        fetchPolicy: 'cache-first',
    });

    useEffect(() => {
        const handleScroll = () => {
            setIsOnTop(window.pageYOffset === 0);
        };

        if (typeof window !== 'undefined') {
            window.addEventListener('scroll', handleScroll);
            return () => window.removeEventListener('scroll', handleScroll);
        }
    }, []);

    if (loading) return null;
    if (error) return <div>Wystąpił błąd podczas ładowania stopki.</div>;

    const block = data?.cmsHydratedBlocks?.items?.[0];
    const footerContent = block?.hydrated_content?.replace(/#html-body/g, 'body') || '';

    const scrollToTopHandler = () => {
        if (typeof window !== 'undefined') {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    return (
        <>
            {!isOnTop && (
                <>
                    <div id="mobile-phone">
                        <a role="navigation" href={`tel:${phoneSupportNumber}`}>
                            <img
                                loading="lazy"
                                alt="mobile-phone"
                                src="/assets/icons/mobile_phone.svg"
                                width={50}
                                height={50}
                            />
                        </a>
                    </div>

                    <div id="scroll-to-top">
                        <button
                            role="navigation"
                            onClick={scrollToTopHandler}
                            style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
                        >
                            <img
                                loading="lazy"
                                alt="scroll-to-top-button"
                                id="scroll-to-top-button"
                                src="/assets/icons/footer-icon-scroll-to-top.png"
                                width={50}
                                height={50}
                            />
                        </button>
                    </div>
                </>
            )}

            <footer className="page-footer">
                {parse(`<div class="footer-container">${footerContent}</div>`, {
                    replace: replaceHTMLNodesWithReact,
                })}
            </footer>
        </>
    );
};

export default memo(Footer);